class UrgencyShipping extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.countdownEl = this.querySelector('.shipping-countdown');
    this.container = this.querySelector('.product-urgency__shipping');
    if (this.countdownEl && this.container) {
      this.updateTimer();
      this.interval = setInterval(this.updateTimer.bind(this), 60000);
    }
  }

  disconnectedCallback() {
    if (this.interval) clearInterval(this.interval);
  }

  updateTimer() {
    const now = new Date();
    const cutoff = new Date();
    cutoff.setHours(14, 0, 0, 0); // 2:00 PM

    if (now > cutoff) {
      cutoff.setDate(cutoff.getDate() + 1);
    }

    const diff = cutoff - now;
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

    this.container.style.display = 'flex';
    this.countdownEl.textContent = `${hours}h ${minutes}m`;
  }
}

class UrgencyCartTimer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.timerEl = this.querySelector('.cart-reservation-timer');
    if (this.timerEl) {
      this.initTimer();
      this.interval = setInterval(this.updateTimer.bind(this), 1000);
    }
  }

  disconnectedCallback() {
    if (this.interval) clearInterval(this.interval);
  }

  initTimer() {
    const DURATION = 10 * 60; // 10 minutes
    const storedTime = sessionStorage.getItem('cartReservationEnd');
    
    if (storedTime) {
      const end = parseInt(storedTime, 10);
      const now = Math.floor(Date.now() / 1000);
      this.timeLeft = end - now;
    } else {
      this.timeLeft = DURATION;
      const end = Math.floor(Date.now() / 1000) + DURATION;
      sessionStorage.setItem('cartReservationEnd', end);
    }
    this.updateTimer();
  }

  updateTimer() {
    if (this.timeLeft <= 0) {
      this.timeLeft = 0;
      this.timerEl.textContent = "00:00";
      return;
    }

    const m = Math.floor(this.timeLeft / 60);
    const s = this.timeLeft % 60;
    
    this.timerEl.textContent = `${m}:${s < 10 ? '0' : ''}${s}`;
    this.timeLeft--;
  }
}

// Define elements if not already defined
if (!customElements.get('urgency-shipping')) {
  customElements.define('urgency-shipping', UrgencyShipping);
}
if (!customElements.get('urgency-cart-timer')) {
  customElements.define('urgency-cart-timer', UrgencyCartTimer);
}
